import React, { useState } from "react";

import {
  FaHeadset,
  FaInfoCircle,
  FaPhone,
  FaEnvelope,
  FaClock,
  FaQuestionCircle,
  FaPaperclip,
  FaPaperPlane,
  FaChevronDown,
} from "react-icons/fa";

import "./Support.css";

function Support() {
  const [formData, setFormData] = useState({
    subject: "",
    category: "",
    description: "",
    attachment: null,
  });

  const [submitted, setSubmitted] = useState(false);

  const tickets = [
    {
      id: "SUP20240001",
      subject: "Membership ID Card",
      date: "20 May 2024",
      status: "Open",
    },
    {
      id: "SUP20240002",
      subject: "Payment Receipt",
      date: "18 May 2024",
      status: "Resolved",
    },
  ];

  const handleChange = (event) => {
    const { name, value, files } = event.target;

    setFormData((previous) => ({
      ...previous,
      [name]: files ? files[0] : value,
    }));
  };

  const handleSubmit = (event) => {
    event.preventDefault();

    setSubmitted(true);

    setTimeout(() => {
      setSubmitted(false);
    }, 3000);
  };

  return (
    <div className="support-page">

      {/* ==================================================
          PAGE HEADER
      ================================================== */}

      <div className="support-page-header">

        <div>
          <h1>Support</h1>

          <div className="support-breadcrumb">
            <span>Home</span>
            <span className="support-breadcrumb-arrow">›</span>
            <span>Support</span>
          </div>
        </div>

      </div>


      {/* ==================================================
          SUCCESS MESSAGE
      ================================================== */}

      {submitted && (
        <div className="support-success-message">
          <FaInfoCircle />
          <span>
            Your support ticket has been submitted successfully.
          </span>
        </div>
      )}


      {/* ==================================================
          MAIN SUPPORT GRID
      ================================================== */}

      <div className="support-main-grid">

        {/* ==================================================
            LEFT COLUMN
        ================================================== */}

        <div className="support-left-column">

          {/* ==================================================
              RAISE SUPPORT TICKET
          ================================================== */}

          <section className="support-card ticket-card">

            <div className="support-section-title">

              <div className="support-section-icon green">
                <FaHeadset />
              </div>

              <div>
                <h2>Raise Support Ticket</h2>

                <p>
                  Submit your issue and our support team will assist you.
                </p>
              </div>

            </div>


            <form
              className="support-form"
              onSubmit={handleSubmit}
            >

              {/* SUBJECT */}

              <div className="support-form-group">

                <label htmlFor="subject">
                  Subject
                  <span>*</span>
                </label>

                <div className="support-select-wrapper">

                  <select
                    id="subject"
                    name="subject"
                    value={formData.subject}
                    onChange={handleChange}
                    required
                  >
                    <option value="">
                      Select subject
                    </option>

                    <option value="membership">
                      Membership
                    </option>

                    <option value="payment">
                      Payment
                    </option>

                    <option value="id-card">
                      ID Card
                    </option>

                    <option value="claim">
                      Claim
                    </option>

                    <option value="profile">
                      Profile Update
                    </option>

                    <option value="other">
                      Other
                    </option>
                  </select>

                  <FaChevronDown />

                </div>

              </div>


              {/* CATEGORY */}

              <div className="support-form-group">

                <label htmlFor="category">
                  Category
                  <span>*</span>
                </label>

                <div className="support-select-wrapper">

                  <select
                    id="category"
                    name="category"
                    value={formData.category}
                    onChange={handleChange}
                    required
                  >
                    <option value="">
                      Select category
                    </option>

                    <option value="account">
                      Account & Profile
                    </option>

                    <option value="membership">
                      Membership
                    </option>

                    <option value="payment">
                      Payment
                    </option>

                    <option value="claims">
                      Claims
                    </option>

                    <option value="documents">
                      Documents
                    </option>

                    <option value="technical">
                      Technical Issue
                    </option>

                    <option value="other">
                      Other
                    </option>
                  </select>

                  <FaChevronDown />

                </div>

              </div>


              {/* DESCRIPTION */}

              <div className="support-form-group">

                <label htmlFor="description">
                  Description
                  <span>*</span>
                </label>

                <textarea
                  id="description"
                  name="description"
                  value={formData.description}
                  onChange={handleChange}
                  placeholder="Describe your issue"
                  rows="7"
                  maxLength="500"
                  required
                />

                <div className="support-character-count">
                  {formData.description.length}/500
                </div>

              </div>


              {/* ATTACHMENT */}

              <div className="support-form-group">

                <label htmlFor="attachment">
                  Attachment
                </label>

                <div className="support-file-upload">

                  <input
                    id="attachment"
                    name="attachment"
                    type="file"
                    accept=".pdf,.jpg,.jpeg,.png"
                    onChange={handleChange}
                  />

                  <div className="support-file-content">

                    <FaPaperclip />

                    <div>
                      <strong>
                        Attach supporting file
                      </strong>

                      <span>
                        PDF, JPG or PNG (Maximum 5MB)
                      </span>
                    </div>

                  </div>

                  <label
                    htmlFor="attachment"
                    className="support-file-button"
                  >
                    Choose File
                  </label>

                </div>

                {formData.attachment && (
                  <p className="selected-file">
                    Selected: {formData.attachment.name}
                  </p>
                )}

              </div>


              {/* SUBMIT */}

              <div className="support-form-actions">

                <button
                  type="submit"
                  className="support-submit-button"
                >
                  <FaPaperPlane />
                  Submit Ticket
                </button>

              </div>

            </form>

          </section>


          {/* ==================================================
              MY SUPPORT TICKETS
          ================================================== */}

          <section className="support-card tickets-card">

            <div className="support-card-header">

              <div>
                <h2>My Support Tickets</h2>

                <p>
                  Track your previously submitted support requests.
                </p>
              </div>

              <span className="ticket-count">
                {tickets.length} Tickets
              </span>

            </div>


            <div className="support-table-wrapper">

              <table className="support-table">

                <thead>

                  <tr>
                    <th>Ticket ID</th>
                    <th>Subject</th>
                    <th>Date</th>
                    <th>Status</th>
                  </tr>

                </thead>

                <tbody>

                  {tickets.map((ticket) => (

                    <tr key={ticket.id}>

                      <td>
                        <strong className="ticket-id">
                          {ticket.id}
                        </strong>
                      </td>

                      <td>
                        {ticket.subject}
                      </td>

                      <td>
                        {ticket.date}
                      </td>

                      <td>

                        <span
                          className={
                            ticket.status === "Resolved"
                              ? "ticket-status resolved"
                              : "ticket-status open"
                          }
                        >
                          {ticket.status}
                        </span>

                      </td>

                    </tr>

                  ))}

                </tbody>

              </table>

            </div>

          </section>

        </div>


        {/* ==================================================
            RIGHT COLUMN
        ================================================== */}

        <aside className="support-right-column">

          {/* ==================================================
              SUPPORT INFORMATION
          ================================================== */}

          <section className="support-side-card">

            <div className="support-side-title">

              <div className="support-side-icon blue">
                <FaInfoCircle />
              </div>

              <h3>
                Support Information
              </h3>

            </div>


            <div className="support-contact-list">

              <div className="support-contact-item">

                <div className="support-contact-icon">
                  <FaPhone />
                </div>

                <div>
                  <span>Phone</span>
                  <strong>
                    +91 91234 56789
                  </strong>
                </div>

              </div>


              <div className="support-contact-item">

                <div className="support-contact-icon">
                  <FaEnvelope />
                </div>

                <div>
                  <span>Email</span>
                  <strong>
                    support@apnbtrust.org
                  </strong>
                </div>

              </div>


              <div className="support-contact-item">

                <div className="support-contact-icon">
                  <FaClock />
                </div>

                <div>
                  <span>Working Hours</span>
                  <strong>
                    Mon - Sat : 9:00 AM - 6:00 PM
                  </strong>
                </div>

              </div>

            </div>

          </section>


          {/* ==================================================
              FAQ
          ================================================== */}

          <section className="support-side-card faq-card">

            <div className="support-side-title">

              <div className="support-side-icon purple">
                <FaQuestionCircle />
              </div>

              <h3>
                Frequently Asked Questions
              </h3>

            </div>


            <div className="faq-list">

              <div className="faq-item">
                <span>
                  How to register?
                </span>
                <span>+</span>
              </div>

              <div className="faq-item">
                <span>
                  How to make payment?
                </span>
                <span>+</span>
              </div>

              <div className="faq-item">
                <span>
                  How to download ID card?
                </span>
                <span>+</span>
              </div>

              <div className="faq-item">
                <span>
                  How to apply for claim?
                </span>
                <span>+</span>
              </div>

            </div>

          </section>


          {/* ==================================================
              NEED HELP
          ================================================== */}

          <section className="support-help-card">

            <div className="support-help-icon">
              <FaHeadset />
            </div>

            <h3>
              Need Help?
            </h3>

            <p>
              Our support team is here to help you.
            </p>

            <button
              type="button"
              onClick={() => {
                window.scrollTo({
                  top: 0,
                  behavior: "smooth",
                });
              }}
            >
              RAISE SUPPORT TICKET
            </button>

          </section>

        </aside>

      </div>


      {/* ==================================================
          INFORMATION MESSAGE
      ================================================== */}

      <div className="support-information-bar">

        <FaInfoCircle />

        <span>
          Please provide accurate information so our support
          team can resolve your issue quickly.
        </span>

      </div>

    </div>
  );
}

export default Support;